import * as React from 'react'
import { ComponentExt } from '@utils/reactExt'
import * as styles from './style/index.scss'
import { FormattedMessage } from 'react-intl'
import SuccessIcon from '@assets/img/global/success.png'
import FailureIcon from '@assets/img/global/failure.png'
import { Button, Toast } from 'antd-mobile'
import { observer, inject } from 'mobx-react'
@inject('addressStoreG')
@observer
class PayResult extends ComponentExt<any, any> {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        sessionStorage.getItem('CHECKOUTID') && this.props.addressStoreG.getResult();
        // 在结果页伪造链接，避免后退导致异常
        window.history.pushState(null, null, '#/global/home');
        window.history.pushState(null, null, '#/global/home/fromPay');
    }
    componentWillUnmount() {
        const {wpwl} = window as any;
        if (wpwl !== undefined && wpwl.unload !== undefined) {
            wpwl.unload();
            const scripts = document.getElementsByTagName('script');
            for (let i = 0; i < scripts.length; i++) {
                if (scripts[i] && scripts[i].src && scripts[i].src.indexOf('paymentWidgets') !== -1) {
                    scripts[i].parentNode.removeChild(scripts[i]);
                }
            }
        }
    }

    render() {
        const { reasonCode } = this.props.match.params
        const orderStatus = this.props.addressStoreG.orderStatus
        const isSuccess = Number(reasonCode) === 100 || orderStatus
        if (!reasonCode && orderStatus === '') { // 支付结果未获取，不展示详情
            return <></>
        }
        return (
            <div className={styles.resultWrap}>
                <img src={isSuccess ? SuccessIcon : FailureIcon} className={styles.statusImg} />
                <p><FormattedMessage id={`pay.${isSuccess ? 'success' : 'fail'}`} /></p>
                {
                    !isSuccess ?
                        <Button className={styles.btnDefault} onClick={() => this.replacePath('/global/home')}>
                            <FormattedMessage id="pay.back" />
                        </Button>
                        :
                        <>
                            <Button className={styles.btn} onClick={() => {this.goToPath('/global/myOrder');}}>
                                <FormattedMessage id="pay.checkOrder" />
                            </Button>
                            <Button className={styles.btnDefault} onClick={() => {this.replacePath('/global/home');}}>
                                <FormattedMessage id="pay.continue" />
                            </Button>
                        </>
                }
            </div>
        )
    }
}

export default PayResult
